function romanNumeral(num) {
  if (!+ num)
    return false;

  var digits = String(+ num).split(""),
    key = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"],
    roman = "",
    i = 3;
  while (i--)
    roman = (key[+ digits.pop() + (i * 10)] || "") + roman;

  return Array(+ digits.join("") + 1).join("M") + roman;
}

/* ============================================================================
 * THE CLOCK LOGIC THAT LIVED HERE HAS MOVED to assets/delivery-clock.js.
 *
 * Deleted from this file (AUDIT: the FIFTH computation, and the one the audit
 * headline was about -- the spec had counted only three):
 *
 *   getCurrentTime()      dayjs().tz('America/Los_Angeles'), else `new Date()`
 *   getCutoffTime()       the 3rd of four AM/PM parsers (D8), whose `if
 *                         (!window.todaysCutoffTime) return currentDayjs.endOf('day')`
 *                         was the 23:59 fallback at the heart of D1
 *   nextDeliveryDate()    walked window.blockOutDates -- i.e. whatever header
 *                         published, exceptions wrongly folded in (D2)
 *   drawTimeUpdates()     ran on setInterval every 1000ms on EVERY page
 *
 * Also deleted, and worth naming because it was a LOADED GUN rather than a bug:
 *
 *   let calendar;         never assigned, so base.js:95 was permanently false
 *   let datepicker;       never assigned, so `typeof datepicker !== 'undefined'`
 *                         was permanently false
 *
 * Those two dangling declarations are the only reason D1 was latent instead of
 * live: they kept a 23:59 cutoff away from datepicker.setOptions({minDate}).
 * Anyone who "fixed" the obvious-looking dangling variable would have armed it
 * that same day. The consolidation removes the gun, not just the trigger.
 *
 * Nothing replaces this here. delivery-views.js drives the DOM, once, from one
 * decision -- and without a 1Hz interval on every page.
 * ========================================================================== */



function addToCart(maidProductID, original_price_in = null) {
  let id = $('input[name=upgradeRadio]:checked').val();

  if (id == null) {
    id = maidProductID;
  }

  let formData = {
    items: [
      {
        id: id,
        quantity: 1,
        properties: {}
      }
    ]
  };

  // Add discounted price as a property
  if (original_price_in !== null && !isNaN(original_price_in)) {
    formData.items[0].properties["original_price_in"] = `$${(parseFloat(original_price_in) / 100).toFixed(2)}`;
  }
  
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      window.location.href = "/cart";
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

function deleteFromCart(id) {
  let formData = {
    updates: {
      [id]: 0
    }
  };
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      location.reload();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}